// @ts-nocheck
import React from 'react'
import { InputProps, TypesProps } from './type'
import { resolveFns } from '../../../utils'
import { IMaskInput } from 'react-imask'
import useInput, { inputTypeProps } from './useInput'
import { Contract } from '../../../utils'

const contract = new Contract()

const Input = React.forwardRef(function Input(
  props: InputProps & TypesProps,
  ref?: React.Ref<HTMLInputElement & HTMLSelectElement & HTMLTextAreaElement> &
    HTMLInputElement
) {
  const {
    parentProps,
    parentClassName = '',
    className = '',
    inputTitle = '',
    inverse = false,
    children,
    actionLeftButtonProps,
    isDisabled,
    onBlurValidate = () => {},
    value = '',
    id = '',
    required = false,
    options,
    disabled = false,
    email = false,
    cep = false,
    cpf = false,
    actionLeft = false,
    cpfEmailUser,
    cpfCnpjEmailUser,
    'cpf-cnpj': String,
    textarea = false,
    loading = false,
    cnpj = false,
    phone = false,
    phoneMobile = false,
    phoneFixed = false,
    text = false,
    date = false,
    number = false,
    password = false,
    search = false,
    action = false,
    select = false,
    hasError = false,
    errorMessage = 'Por favor, preencha este campo corretamente.',
    messageProps,
    actionButtonProps = {},
    onChange,
    onBlur,
    onKeyDown,
    onKeyUp,
    ...rest
  } = props

  const { inputType, mdnClasses } = useInput(Object.keys(props))
  // @ts-ignore
  const { title, type, fn, mask }: inputTypeProps = inputType
  const [maskDynamicType, setMaskDynamicType] = React.useState(type)
  const [dynamicTypeForcedRef, setDynamicTypeForceRef] = React.useState(null)
  const {
    actionButtonClassName = '',
    actionButtonLabel = '',
    ...actionButtonRest
  } = actionButtonProps
  const [currentValue, setCurrentValue] = React.useState(value)
  const [error, setError] = React.useState({
    message: errorMessage,
    hasError: hasError
  })
  const [hidden, setHidden] = React.useState(true)
  const [requiredField, setRequiredField] = React.useState(required)
  const [actualMask, setActualMask] = React.useState(mask);

  const handleChange = (event, _mask) => {
    setCurrentValue(event.target.value)

  }

  const inputId =
    id !== ''
      ? id
      : `input__${new Date()
        .valueOf()
        .toString()
        .match(/\d{6}$/)[0]
      }`

  const checkCapsLock = (event) => {
    if (event.getModifierState('CapsLock')) {
      setError({
        hasError: true,
        message: 'Capslock ativado!'
      })
    } else {
      setError({
        hasError: false
      })
    }
  };

  const handleBlur = (e) => {
    if (typeof fn !== 'undefined' && typeof fn === 'function') {
      const isValid = fn(e.target.value, error.message)
      onBlurValidate(!isValid.hasError);
      setError({
        hasError: isValid.hasError,
        message: error.message
      })
    }

    if (required === true) {
      if (e.target.value !== '') {
        setRequiredField(false)
      } else {
        setRequiredField(true)
      }
    } else {
      if (e.target.value === '') {
        setError({
          hasError: false,
          message: error.message
        })
      }
    }

  }

  const bindEventsToForm = (input) => {
    let form = input.closest('form')

    if (!form) return

    form.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        input.type = !contract.isEmail(input.value) ? 'text' : 'email'
      }
    })
    form.querySelectorAll('[type=submit]').forEach((item) => {
      item.addEventListener('click', (e) => {
        input.type = !contract.isEmail(input.value) ? 'text' : 'email'
      })
    })
  }

  React.useEffect(() => {
    setCurrentValue(value)
  }, [value])

  React.useEffect(() => {
    setError({ message: errorMessage, hasError: hasError })
  }, [hasError, errorMessage])


  function renderInputField() {
    const fields = {
      textarea: (
        <>
          <textarea
            {...rest}
            id={inputId}
            className={'mdn-Input-field ' + (className || '')}
            data-mdn-type={title}
            ref={ref}
            onChange={resolveFns(handleChange, onChange)}
            onBlur={resolveFns(handleBlur, onBlur)}
            disabled={isDisabled || disabled}
            value={currentValue}
          />
          <label htmlFor={inputId} className="mdn-Input-label">
            {children}
          </label>
        </>
      ),
      select: (
        <>
          <select
            {...rest}
            id={inputId}
            className={'mdn-Input-field ' + (className || '')}
            data-mdn-type={title}
            onChange={resolveFns(handleChange, onChange)}
            value={currentValue}
            ref={ref}
            onBlur={resolveFns(handleBlur, onBlur)}
            disabled={isDisabled || disabled}
            style={{ backgroundImage: 'none' }}
          >
            {options?.map((option, index) => (
              <option key={index} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
          <span className="mdn-Icon-baixo mdn-Icon--md mdn-Input-select-arrow"></span>
          <label htmlFor={id} className="mdn-Input-label">
            {children}
          </label>
        </>
      ),
      action: (
        <>
          <input
            {...rest}
            id={inputId}
            className={`mdn-Input-field ${className}`}
            data-mdn-type={title}
            type={type}
            ref={ref}
            required={required}
            onChange={resolveFns(handleChange, onChange)}
            onBlur={resolveFns(handleBlur, onBlur)}
            disabled={isDisabled || disabled}
            defaultValue={value}
          />
          <label htmlFor={inputId} className="mdn-Input-label">
            {children}
          </label>
          <button
            className={`mdn-Input-action ${actionButtonClassName}`}
            aria-label="Enviar"
            {...actionButtonRest}
            {...actionButtonProps}
          >
            {actionButtonLabel ? (
              <span>{actionButtonLabel}</span>
            ) : (
              <i className="mdn-Icon-direita mdn-Icon--md"></i>
            )}
          </button>
        </>
      ),

      actionLeft: (
        <>
          <button className="mdn-Input-button-edit" aria-label="Enviar" {...actionLeftButtonProps}>
            <i aria-hidden="true" className="mdn-Icon-lapis mdn-Icon--sm"></i>
            <span className="mdn-Text mdn-Text-icon">Editar</span>
          </button>
          <input
            {...rest}
            id={inputId}
            className={`mdn-Input-field ${className}`}
            data-mdn-type={title}
            type={type}
            ref={ref}
            readOnly
            value={value}
          />
          <label htmlFor={inputId} className="mdn-Input-label">
            {children}
          </label>
          <small className="mdn-Input-errorFeedback">Por favor, preencha este campo corretamente.</small>
        </>
      ),
      number: (
        <>
          <input
            {...rest}
            id={inputId}
            className={'mdn-Input-field ' + (className || '')}
            data-mdn-type={title}
            type={title}
            ref={ref}
            required={required}
            onChange={resolveFns(handleChange, onChange)}
            onBlur={resolveFns(handleBlur, onBlur)}
            disabled={isDisabled || disabled}
            value={currentValue}
          />
          <label htmlFor={inputId} className="mdn-Input-label">
            {children}
          </label>
        </>
      ),
      email: (
        <>
          <input
            {...rest}
            id={inputId}
            className={'mdn-Input-field ' + (className || '')}
            data-mdn-type={title}
            type={title}
            ref={ref}
            required={required}
            defaultValue={value}
            onChange={resolveFns(handleChange, onChange)}
            onBlur={resolveFns(handleBlur, onBlur)}
            disabled={isDisabled || disabled}
          />
          <label htmlFor={inputId} className="mdn-Input-label">
            {children}
          </label>
        </>
      ),
      password: (
        <>
          <input
            {...rest}
            id={inputId}
            className={'mdn-Input-field ' + (className || '')}
            type={hidden ? 'password' : 'text'}
            data-mdn-type="password"
            defaultValue={value}
            ref={ref}
            onChange={resolveFns(handleChange, onChange)}
            onBlur={resolveFns(handleBlur, onBlur)}
            onKeyUp={resolveFns(checkCapsLock, onKeyUp)}
            required={required}
            disabled={isDisabled || disabled}
          />
          <label htmlFor={inputId} className="mdn-Input-label">
            {children}
          </label>
          <button
            className="mdn-Input-action"
            type="button"
            data-mdn-action="reveal-password"
            onClick={() => setHidden(!hidden)}
            role="button"
          >
            <span
              aria-label={`${hidden ? 'Ocultar senha' : 'Exibir senha'} `}
              className={`${hidden ? 'mdn-Icon-exibir' : 'mdn-Icon-ocultar'
                } mdn-Icon--md`}
            />
          </button>
        </>
      ),
      search: (
        <>
          <input
            id={inputId}
            className="mdn-Input-field"
            type="text"
            ref={ref}
            data-mdn-type="search"
            onChange={resolveFns(handleChange, onChange)}
            onBlur={resolveFns(handleBlur, onBlur)}
            defaultValue={value}
          />
          <label htmlFor={inputId} className="mdn-Input-label">
            {children}
          </label>
          <button
            onClick={resolveFns((e) =>
              setCurrentValue(() => {
                e.target.value = ''
                onChange(e)
                return ''
              })
            )}
            className="mdn-Input-action"
            role="button"
          >
            <span
              className={`${!currentValue ? 'mdn-Icon-busca' : 'mdn-Icon-fechar'
                } mdn-Icon--md`}
              aria-label="Search"
            ></span>
          </button>
        </>
      ),
      date: (
        <>
          <input
            {...rest}
            // @ts-ignore
            mask={mask}
            ref={ref}
            id={inputId}
            data-mdn-type={title}
            className="mdn-Input-field" //{ + (props?.className || '')}
            type={title}
            defaultValue={value}
            onChange={resolveFns(handleChange, onChange)}
            onBlur={resolveFns(handleBlur, onBlur)}
            disabled={isDisabled || disabled}
          />
          <label htmlFor={inputId} className="mdn-Input-label">
            {children}
          </label>
        </>
      ),
      default: (
        <>
          <IMaskInput
            {...rest}
            mask={actualMask}
            id={inputId}
            title={inputTitle ? inputTitle : title}
            type={maskDynamicType}
            value={currentValue}
            defaultValue={value}
            className={'mdn-Input-field ' + (className || '')}
            data-mdn-type={inputType.title}
            inputRef={ref}
            ref={ref}
            onBlur={resolveFns(handleBlur, onBlur)}
            onInput={(e) => {
              if (!inputType.hasDynamicValue) return
              if (!dynamicTypeForcedRef) {
                bindEventsToForm(e.target)
              }
              setDynamicTypeForceRef(e.target)

              if (title == 'multiple' && (e.target.value.length >= 11)) {

                const validateValue = e.target.value.replace(/\D/g, '');

                if (validateValue.length == 11) {
                  const isCpf = contract.validateIsCpf(validateValue);
                  !isCpf && setActualMask([
                    { mask: '0000000000' }, { mask: '(00) 0 0000-0000' }, { mask: '00.000.000/0000-00' }
                  ])
                } else {
                  setActualMask(mask)
                }

              } else if (title == 'multiple') {
                setActualMask(mask)
              }
            }}
            // @ts-ignore
            onAccept={(v, ref, event) => {
              if (title == 'multiple' && v.length >= 14) {

                const validateValue = v.replace(/\D/g, '');

                if (validateValue.length == 11) {
                  const isCpf = contract.validateIsCpf(validateValue);
                  !isCpf && setActualMask([
                    { mask: '0000000000' }, { mask: '(00) 0 0000-0000' }, { mask: '00.000.000/0000-00' }
                  ])
                } else {
                  setActualMask(mask)
                }

              } else if (title == 'multiple') {
                setActualMask(mask)
              }
              resolveFns(
                () => handleChange,
                setCurrentValue(v),
                onChange
                  ? onChange({
                    target: {
                      value: v,
                      ...rest
                    },
                    maskInput: ref,
                    originalEvent: event
                  } as unknown as ChangeEvent<HTMLInputElement>)
                  : onChange
              )
            }
            }
            onChange={(e) => { handleChange(e); onChange }}
            required={requiredField}
            disabled={isDisabled || disabled}
          />
          <label
            htmlFor={inputId}
            aria-required="true"
            className="mdn-Input-label"
          >
            {children}
          </label>
        </>
      )
    }
    return fields[title] || fields.default
  }

  return !loading ? (
    <div
      className={`${mdnClasses} ${inverse ? 'mdn-Input--inverse' : ''}
                      ${(currentValue || date) ? 'mdn-Input--activatedField' : ''}
                      ${error.hasError ? 'mdn-Input--attentionField' : ''}
                      ${actionLeft ? 'mdn-Input-action--left' : ''}
                      ${parentClassName}`
        .replace(/\s{2,}/g, ' ')
        .trim()}
    >
      {props.text ? (
        <>
          <input
            id={inputId}
            ref={ref}
            className="mdn-Input-field"
            type="text"
            onChange={resolveFns(handleChange, onChange)}
            onBlur={resolveFns(handleBlur, onBlur)}
            data-mdn-type="text"
            value={currentValue}
            disabled={isDisabled || disabled}
            {...rest}
          />
          <label htmlFor={inputId} className="mdn-Input-label">
            {children}
          </label>
        </>
      ) : (
        renderInputField()
      )}
      {messageProps && (
        <small class="mdn-Input-messageFeedback">
          <em class={`mdn-Icon-${messageProps.icon} mdn-Icon--sm`}></em>
          {messageProps.text}
        </small>
      )}
      {error.hasError && (
        <small className="mdn-Input-errorFeedback">{error.message}</small>
      )}
    </div>
  ) : (
    <div className="mdn-Skeleton" aria-busy="true">
      <div
        className={`mdn-Skeleton-item ${textarea ? 'mdn-Skeleton-textarea' : 'mdn-Skeleton-input'
          } mdn-Input-field `}
      ></div>
    </div>
  )
})

export default Input
